import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { searchDealers } from '@/api/dealers';
import { addTallyDispatch } from '@/api/orders-dispatches';
import router from '@/router';
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-module-decorators';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.form = {
      dealerId: null,
      invoiceNumber: null,
      invoiceDate: null,
      grandTotal: null,
      subTotal: null,
      discountAmount: null,
      taxAmount: null,
      roundOffAmount: null
    };
    this.rules = {
      dealerId: [{
        required: true,
        message: 'Please select dealer',
        trigger: 'blur'
      }],
      invoiceNumber: [{
        required: true,
        message: 'Please enter invoice number',
        trigger: 'blur'
      }],
      invoiceDate: [{
        required: true,
        message: 'Please select invoice date',
        trigger: 'blur'
      }],
      grandTotal: [{
        required: true,
        message: 'Please enter grand total',
        trigger: 'blur'
      }]
    };
    this.dealerListLoading = false;
    this.dealerList = [];
    this.loading = false;
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      this.dealerList = await searchDealers({
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name'
      });
    } catch (error) {} // eslint-disable-line  no-empty
  }
  submitForm() {
    this.$refs.form.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.form.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      await addTallyDispatch(this.form);
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Dispatch added successfully',
        type: 'success',
        duration: 2000
      });
      router.push({
        path: '/orders-dispatches/list'
      });
    } catch (error) {
      if (error instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: error.message
        });
      }
      this.loading = false;
    }
  }
};
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'OrdersDispatchesTally'
})], default_1);
export default default_1;